import { motion } from 'framer-motion'
import { StyleContentWrapper } from '@pages/front/commons/ContentWrapper/style'
import { TextWrapper } from '@pages/front/commons/Text'
import React from 'react'
import { IFaq } from '@pages/front/types/type'
import FaqRow from './FaqRow'

const MotionStyleContentWrapper = motion(StyleContentWrapper)
const MotionTextWrapper = motion(TextWrapper)

const Faq = ({ faqData }: { faqData?: IFaq[] }) => {
  return (
    <MotionStyleContentWrapper
      paddingRight="60"
      paddingLeft="60"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
    >
      <MotionTextWrapper
        title="Frequently Asked, Clearly Answered"
        subtitle={`"Start here to solve doubts and learn more about the app."`}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.6, delay: 0.3 }}
      />
      <FaqRow faqData={faqData} />
    </MotionStyleContentWrapper>
  )
}

export default Faq
